import { IntegrationTypeCardController } from '../controller/IntegrationTypeCardController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IntegrationTypeCardWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationTypeCardController,
    });
  }

  get nonUserConfigurable() {
    const value = this.getAttribute('data-configurable');
    return value === 'true';
  }

  set nonUserConfigurable(nonUserConfigurable: boolean) {
    this.setAttribute('data-configurable', nonUserConfigurable.toString());
  }

  get type() {
    const value = this.getAttribute('data-type');
    return value ? parseInt(value, 10) : 0;
  }

  set type(type: number) {
    this.setAttribute('data-type', type.toString());
  }

  get description(): string {
    return this.getAttribute('data-description') ?? '';
  }

  set description(description) {
    this.setAttribute('data-description', description);
  }

  get integrationType(): string {
    return this.getAttribute('data-integration-type') ?? '';
  }

  set integrationType(integrationType) {
    this.setAttribute('data-integration-type', integrationType);
  }

  get license() {
    const value = this.getAttribute('data-license');
    return value ? JSON.parse(value) : [];
  }

  set license(license) {
    this.setAttribute('data-license', JSON.stringify(license));
  }

  get name(): string {
    return this.getAttribute('data-name') ?? '';
  }

  set name(name) {
    this.setAttribute('data-name', name);
  }
}
